import React from 'react';
import { Button } from '@nextui-org/react';
import { MdOutlineError } from 'react-icons/md';

class ErrorBoundary extends React.Component {
  state = { hasError: false, error: null, errorInfo: null };

  static getDerivedStateFromError(error) {
    // Update state to show fallback UI on error
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error to an error reporting service
    console.error('Error caught by ErrorBoundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Fallback UI when there's an error
      return (
        <div className="flex item-center justify-center my-3">
          <Button
            disableAnimation={true}
            variant="flat"
            startContent={<MdOutlineError fill="red" size={16} />}
            className="text-md text-red-500 font-semibold bg-transparent cursor-default"
          >
            Oops! Something went wrong
          </Button>
        </div>
      );
    }

    return this.props.children; // Render children if no error
  }
}

export default ErrorBoundary;
